<template>
  <slot />
  <div
    v-for="(toast, index) in toastProvider.toasts"
    :key="index"
    :class="
      classNames('fixed z-50 max-w-sm w-full shadow-lg rounded-lg pointer-events-auto overflow-hidden transition-all', {
        'top-4 left-1/2 transform -translate-x-1/2': toast.position === 'top-center',
        'bottom-4 left-1/2 transform -translate-x-1/2': toast.position === 'bottom-center',
        'top-4 right-4': toast.position === 'top-right',
        'bottom-4 right-4': toast.position === 'bottom-right',
        'top-4 left-4': toast.position === 'top-left',
        'bottom-4 left-4': toast.position === 'bottom-left',
        'bg-green-200': toast.status === 'success',
        'bg-red-200': toast.status === 'error',
        'bg-orange-200': toast.status === 'warning',
        'bg-blue-200': toast.status === 'info',
      })
    "
    :style="{
      marginTop: toast.position.includes('top')
        ? `${
            toastProvider.toasts
              .filter(({ position }) => position === toast.position)
              .findIndex(({ id }) => id === toast.id) * 6
          }rem`
        : '',
      marginBottom: toast.position.includes('bottom')
        ? `${
            toastProvider.toasts
              .filter(({ position }) => position === toast.position)
              .findIndex(({ id }) => id === toast.id) * 6
          }rem`
        : '',
    }"
  >
    <div class="p-4">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <!-- Icon can be added here -->
        </div>
        <div class="ml-3 w-0 flex-1 pt-0.5">
          <span class="text-sm font-medium text-gray-900">{{ toast.message }}</span>
        </div>
        <div class="flex flex-shrink-0 ml-4">
          <button
            :class="classNames('rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none')"
            @click="toastProvider.removeToast(toast.id)"
          >
            <span class="sr-only">Close</span>
            <!-- Heroicon name: x -->
            <svg
              class="w-5 h-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const toastProvider = initToast();

provide("useToast", toastProvider);
</script>
